import { render, staticRenderFns } from "./ChoiceCard.vue?vue&type=template&id=744d0e4b&scoped=true"
import script from "./ChoiceCard.vue?vue&type=script&lang=js"
export * from "./ChoiceCard.vue?vue&type=script&lang=js"
import style0 from "./ChoiceCard.vue?vue&type=style&index=0&id=744d0e4b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744d0e4b",
  null
  
)

export default component.exports